<div class="video-card-bg flex w100p jcc aic gus-cursor-pointer br24">
  @if (!imageLoaded) {
    <div class="skeleton-loader"></div>
  } @else {
    <div class="flex w100p jcc aic gus-cursor-pointer br24" [ngStyle]="{
      'background-image': 'url(' + img + ')',
      'background-size': 'cover',
      'background-repeat': 'no-repeat',
      'background-position': 'center',
    }">
      <div class="view-container flex-row flex-nosize aic jcc gus-font-regular fs16">
        <span class="label flex flex-row flex-nosize aic jcc gus-color-blue-dark gus-font-semi-bold text-transform-uppercase space-letter-047 fs16 gap10">
          View Class
          <div class="oval flex flex-nosize jcc aic">
            <gus-icon name="arrow-right-white" class="flex-nosize" width="12px" height="12.8px"></gus-icon>
          </div>
        </span>
      </div>
    </div>
  } 
  <div class="overlay"></div>
</div>

<div class="info-block flex flex-nosize w100p">
  <span class="title flex flex-nosize gus-truncate-text gus-font-semi-bold fs16">
    {{item.title}}
  </span>
  <div class="divider"></div>
  <div class="flex flex-nosize">
      <span class="instructor flex-row gus-font-light space-letter-047 line-height-24 fs16 aife">  
        @if(item.instructor) { 
          <span class="gus-text-gray">Instructor:</span>
          {{item.instructor.full_name}}
        }
      </span>
    <span class="duration flex-row gus-font-light space-letter-047 line-height-24 fs16 aife">
      <span class="gus-text-gray">Duration:</span>
      {{item.duration}}m
    </span>
  </div>

</div>